import React from "react";
import { motion } from "framer-motion";

const Banner = ({ title, image, desc, text1, text2 }) => {
  return (
    <>
      <motion.div
        initial={{ x: -500 }}
        animate={{ x: 0 }}
        transition={{
          ease: "linear",
          duration: 0.5,
        }}
        className="hidden md:flex flex-col-reverse md:flex-row mt-10 rounded-2xl shadow-xl border w-full items-center"
      >
        <div className="w-full md:w-1/2  p-10">
          <h1 className="ml-10 text-2xl sm:text-4xl md:text-4xl lg:text-4xl text-gray-700 font-extrabold">
            {title}
          </h1>
          <p className="ml-10 mt-5 text-gray-500">{desc}</p>
          <div className="ml-10 mt-5 text-gray-500">
            <div className="flex gap-10">
              <div className="">
                {text1?.map((item, i) => (
                  <p key={i}>{item}</p>
                ))}
              </div>
              <div className="">
                {text2?.map((item, i) => (
                  <p key={i}>- {item}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full md:w-1/2 p-10 flex justify-center items-center">
          <img src={image} className="h-72 rounded-xl" alt="" />
        </div>
      </motion.div>
      <div className="w-full mt-5 border flex md:hidden items-center justify-center px-4 py-10 rounded-xl gap-3">
        <div className="">
          <h1 className="text-xl text-gray-700 mb-3">{title}</h1>
          <img src={image} className="" alt="" />
          <p className="text-xs text-gray-500 tracking-widest mb-3">{desc}</p>
          <div className="mt-5 text-gray-500">
            <div className="flex gap-3">
              <div className="">
                {text1?.map((item, i) => (
                  <p key={i} className="text-[10px] mb-3">{item}</p>
                ))}
              </div>
              <div className="">
                {text2?.map((item, i) => (
                  <p key={i} className="text-[10px] mb-3">- {item}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
